var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

const React = require('react');
const Icon = require('@infotech/uikit-icon').default;

function Svg(props) {
  const svgProps = Object.assign({}, props);
  const title = props.title;
  delete props.title;

  /* <svg {...svgProps} ><title>{title}<title>...</svg> */
  return React.createElement(
    'svg',
    _extends({ width: '24', height: '24', viewBox: '-3 -2 24 24', focusable: 'false' }, svgProps, { 'aria-labelledby': 'title' }),
    React.createElement(
      'title',
      { id: 'title' },
      title
    ),
    React.createElement('path', { d: 'M6 14.118h12V15a1 1 0 01-1 1H5c-.552 0-1-.421-1-.941V.94C4 .421 4.448 0 5 0h8.086c.265 0 .52.1.707.276l3.914 3.684a.914.914 0 01.293.665v9.493h-2v-8.47h-3a1 1 0 01-1-1V1.882H6v12.236zm2-4.706c-.552 0-1-.422-1-.941 0-.52.448-.942 1-.942h6c.552 0 1 .422 1 .942s-.448.94-1 .94H8zm0 .94h3c.552 0 1 .423 1 .942 0 .52-.448.941-1 .941H8c-.552 0-1-.421-1-.94 0-.52.448-.942 1-.942zM2 18h11a1 1 0 010 2H1a1 1 0 01-1-1V5a1 1 0 112 0v13z', fillRule: 'evenodd', role: 'presentation' })
  );
}

module.exports = function reports(props) {
  return React.createElement(Icon, _extends({ glyph: Svg }, props));
};